import { render, staticRenderFns } from "./ModalAddUnit.vue?vue&type=template&id=372d3a8a"
import script from "./ModalAddUnit.vue?vue&type=script&lang=js"
export * from "./ModalAddUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports